import { createStore } from "vuex";

export default createStore({
  state: {
    world: require("../../public/data/data-world"),
    maps: {
      Story1: require("../../public/data/data-mapStory1"),
      Story2: require("../../public/data/data-mapStory2"),
      Ev1: require("../../public/data/data-mapEv1"),
      Ev2: require("../../public/data/data-mapEv2"),
      Ev3: require("../../public/data/data-mapEv3"),
      Ev4: require("../../public/data/data-mapEv4"),
      Ev5: require("../../public/data/data-mapEv5"),
      Ev6: require("../../public/data/data-mapEv6"),
      Ev7: require("../../public/data/data-mapEv7"),
      Ev8: require("../../public/data/data-mapEv8"),
      Ev9: require("../../public/data/data-mapEv9"),
      Ev10: require("../../public/data/data-mapEv10"),
      Ev11: require("../../public/data/data-mapEv11"),
      Ev12: require("../../public/data/data-mapEv12"),
      Ev13: require("../../public/data/data-mapEv13"),
      Ev14: require("../../public/data/data-mapEv14"),
      Ev15: require("../../public/data/data-mapEv15"),
      Ev16: require("../../public/data/data-mapEv16"),
      Ev17: require("../../public/data/data-mapEv17"),
      Ev18: require("../../public/data/data-mapEv18"),
      Ev19: require("../../public/data/data-mapEv19"),
      Cha: require("../../public/data/data-mapCha"),
      Daily: require("../../public/data/data-mapDaily"),
    },
    enemies: require("../../public/data/data-enemy"),
    skills: require("../../public/data/data-skill"),
    activeEnemy: ["", 0],
    sanctum: require("../../public/data/data-sanctum"),
  },
  getters: {
    getMaps(state) {
      return state.maps;
    },
    getEnemies(state) {
      return state.enemies;
    },
    getSkills(state) {
      return state.skills;
    },
    getActiveEnemy(state) {
      return state.activeEnemy;
    },
    getWorld(state) {
      return state.world;
    },
    getSanctum(state) {
      return state.sanctum;
    },
  },
  mutations: {
    async UPDATEMAPS(state) {
      let types = ["story", "event", "challenge", "daily"];
      types.forEach((e) => {
        state.world[e].forEach((element) =>
          fetch("data/data-map" + element + ".json")
            .then((resp) => resp.json())
            .then((data) => Promise.resolve((state.maps[element] = data)))
        );
      });
    },
    async INIT(state, data) {
      state.enemies = data[0];
      state.skills = data[1];
    },
    SETACTIVEENEMY(state, data) {
      state.activeEnemy = data;
    },
  },
  actions: {
    async requestMaps({ commit, state }) {
      if (Object.keys(state.maps).length == 0) {
        await commit("UPDATEMAPS");
      }
    },
    async init({ commit, state }) {
      if (state.enemies.length == 0 || state.skills.length) {
        const enemies = await fetch("data/data-enemy.json").then((resp) =>
          resp.json()
        );
        const skills = await fetch("data/data-skill.json").then((resp) =>
          resp.json()
        );
        commit("INIT", [enemies, skills]);
      } else {
        return;
      }
    },
    setActiveEnemy({ commit }, data) {
      commit("SETACTIVEENEMY", data);
    },
  },
});
